// ---------------------------------------------------------
// Datei: storageErrors.ts
// Zweck: Erkennung von Speicherplatz-Fehlern (localStorage/IndexedDB),
//        die browserübergreifend unterschiedliche name/code/message-
//        Kombinationen tragen. Bisher dupliziert in dealsStore.ts und
//        documentState.ts - hier für neue Verwendungsstellen (z.B. die
//        Upload-Queue) an einer Stelle gebündelt.
// ---------------------------------------------------------

export function isQuotaExceededError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const { name, code, message } = error as { name?: unknown; code?: unknown; message?: unknown };
  const normalizedMessage = String(message ?? '').toLowerCase();
  return (
    name === 'QuotaExceededError' ||
    name === 'NS_ERROR_DOM_QUOTA_REACHED' ||
    code === 22 ||
    code === 1014 ||
    normalizedMessage.includes('quota') ||
    normalizedMessage.includes('exceeded')
  );
}
